
export function getFeetAndInchesFromText(value: string): {feet: number, inches: number}
{
    const arr: string[] = value.split(" ");

    let feet = parseFloat(arr[0].replace(/'/g, ""));
    let inches = parseFloat(arr[1].replace(/"/g, ""));

    return {
        feet,
        inches
    };
}

export function getTotalFromFeetAndInchesText(value: string): number | undefined {

    const item = getFeetAndInchesFromText(value);

    if (item.feet === undefined && item.inches === undefined) {
        return undefined;
    }
    const feet = item.feet ?? 0;
    const inches = item.inches ?? 0;

    return (feet * 12) + inches;

}

export function getFeetAndInchesValue(totalInches: number): {feet: number, inches: number} {
    var decimalft: number = (totalInches / 12);
    var ft: number = (decimalft < 0 ? Math.ceil(decimalft) : Math.floor(decimalft));
    var inches: number = Math.round(((decimalft - ft) * 12) * Math.pow(10, 2)) / Math.pow(10, 2);

    if (inches === 12.0) {
        ft++;
        inches = 0.0;
    }

    return { 
        feet: ft, 
        inches: inches 
    };
}


export function getFeetAndInchesText(totalInches?: number) {
    if (totalInches === null || totalInches === undefined) {
        return "";
    }

    let o = getFeetAndInchesValue(totalInches as number);

    var sign = (o.feet < 0 || o.inches < 0 ? "-" : "");
    var s = o.feet + "' " + o.inches.toFixed(2) + "\"";
    s = s.replace("-", "");
    return (sign + s);
}